export enum ImageSizing {
  OVERFLOW = 'OVERFLOW',
  MATCH_HEIGHT = 'MATCH_HEIGHT',
  MATCH_WIDTH = 'MATCH_WIDTH',
  IMAGE_75 = 'IMAGE_75',
}
